import {get} from 'application/api/baseApi';

export type Response = [
  {
    logID: number;
    date: string;
    type: string;
    contact: string;
    userID: number;
    message: string;
  }
];

const path = '/getContactLog';

/**
 * Middleware for {@link get | the generic API "get" function}.
 * @remark Adds type restrictions and the path parameter.
 * @returns Expected response or null
 */
const getContactLogAPI = (userID: string) => get<Response>(path, {params: {userID}});

export default getContactLogAPI;